import ApiResource from './ApiResource';

class InvoiceResource extends ApiResource {
  public endpoint = '/invoices';
}

export const invoiceResource = new InvoiceResource();
